<template>
  <div class="register-terms-dialog dialog-mask" v-if="visible">
    <div class="dialog-main">
      <div class="dialog-header">
        <div class="dialog-title">{{ title }}</div>
        <span class="icon-close" @click="onClickCloseBtn">×</span>
      </div>

      <div class="dialog-content" v-html="content"></div>
      <div class="dialog-footer">
        <button type="button" class="btn-confirm" @click="onClickConfirmBtn">{{$t('widgets_basic_member_register_compoments_dialog_2626')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "basic_member_rigister_dialog",
  props: {
    title: String,
    content: String,
  },
  data() {
    return {
      visible: true
    }
  },
  methods: {
    onClickCloseBtn() {
      this.visible = false
    },
    onClickConfirmBtn() {
      this.visible = false
      $('.basic-member-register .checkbox-read-wrapper .my-checkbox').prop('checked', true) // 这种写法很恶心，但是我不知道dialog.vue和index.vue之间适合的通信方法是怎样
    }
  }
}
</script>

<style scoped lang="scss">
.register-terms-dialog {
  position: fixed;
  z-index: 1999;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);

  .dialog-main {
    margin-top: 15vh;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    background: #fff;
    padding: 30px;
  }

  .dialog-header {
    position: relative;
    border-bottom: 1px solid #dddddd;
    padding-bottom: 10px;
  }

  .dialog-title {
    text-align: center;
    font-size: 24px;
    color: #333;
    width: 90%;
    line-height: 1.4;
  }

  .icon-close {
    font-size: 20px;
    position: absolute;
    top: -10px;
    right: 10px;
    cursor: pointer;


    &:hover {
      color: var(--theme_color);
    }
  }

  .dialog-content {
    height: 55vh;
    overflow-y: auto;
    font-size: 14px;
    line-height: 1.75;
    padding: 0 30px 30px 30px;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
  }

  .btn-confirm {
    height: 45px;
    line-height: 45px;
    background: var(--theme_color);
    color: #fff;
    border: none;
    outline: none;
    cursor: pointer;
    padding-left: 20px;
    padding-right: 20px;
  }
}

.mb_pattern .register-terms-dialog {
  .dialog-title {
    font-size: 22px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .dialog-content {
    height: calc(100% - 200px);
  }
}

.mb_pattern .register-terms-dialog .dialog-main {
  margin-top: 164px;
  width: 375px;
  height: 667px;
  max-height: calc(100% - 122px);
  padding-left: 20px;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_member_register/compoments/dialog.vue